import type { DailySummary, Sample } from "../../lib/OnlineTypes";
import React, { Fragment, useState } from "react";
import styled, { css } from "styled-components";
import { MinimalContainer, DataTable } from "./Theme";
import { smallDate } from "../../lib/DateFormatting";
import Button from "../Button";

const Container = styled(MinimalContainer)`
  margin-top: 0px;
  max-width: 1920px;
  border-top: 0px;
`;

const Th = styled.th``;
//   border-bottom: 1px solid #bbb;
//   text-decoration: uppercase;
//   font-weight: bold;
//   background-color: #23b7e5;
//   color: white !important;
//   text-transform: uppercase;
//   vertical-align: middle !important;
//   text-align: center !important;
//   padding: 10px 8px !important;
// `;

const Td = styled.td`
  text-align: center !important;
  border-right: 1px solid #eee;
  padding: 3px !important;
`;

const DateTd = styled(Td)`
  text-transform: uppercase;
  font-weight: bold;
  color: #aaa;
`;

const CountTd = styled(Td)`
  color: #ddd;
`;

const ExceededTd = styled(CountTd)`
  ${(props) =>
    props &&
    props.selected &&
    css`
      color: white !important;
      font-weight: bold;
      background-color: #ffa3a3 !important;
      border: 0px;
    `};
`;
const FailTd = styled(ExceededTd)`
  ${(props) =>
    props.count &&
    props.count > 0 &&
    css`
      color: red;
      font-weight: bold;
    `};
`;
const WarningTd = styled(ExceededTd)`
  ${(props) =>
    props.count &&
    props.count > 0 &&
    css`
      color: orange;
      font-weight: bold;
    `};
`;

const SummaryTable = styled(DataTable)`
  table-layout: fixed;
  margin-bottom: 0;
  cursor: pointer;
`;

export default function DailySummaryTable({
  dailySummary,
  company_id,
  loadSamplesForDate,
  selectedDate,
  loading,
}) {
  const [failureSelected, setFailureSelected] = useState(false);
  return (
    <Container>
      <SummaryTable>
        <thead>
          <tr>
            <th>{I18n.t(dailySummary.date_filter, { scope: "daily_summary" })}</th>
            <th>{I18n.t("samples_received")}</th>
            <Th className="hidden-sm hidden-xs">{I18n.t("test_count")}</Th>
            <th>{I18n.t("failed_tests")}</th>
            <Th>{I18n.t("warning_tests")}</Th>
            <Th className="hidden-sm hidden-xs">{I18n.t("outstanding_todos")}</Th>
            <Th className="hidden-sm hidden-xs">{I18n.t("total_price")}</Th>
          </tr>
        </thead>
      </SummaryTable>
      <div style={{ overflowY: "auto", maxHeight: 300 }}>
        <SummaryTable>
          <tbody>
            {dailySummary.dates.map((date) => (
              <tr
                key={date.date}
                onClick={() => {
                  loadSamplesForDate(date.date, false);
                  setFailureSelected(false);
                }}
                className={selectedDate == date.date && !failureSelected ? "selectedDate" : ""}
              >
                <DateTd>
                  {selectedDate == date.date &&
                    loading && (
                      <span>
                        <i className="fa fa-spin fa-spinner" />
                        &nbsp;&nbsp;
                      </span>
                    )}
                  {smallDate(date.date)}
                </DateTd>
                <Td>
                  {date.samples_registered} / {date.samples_received}
                </Td>
                <Td className="hidden-sm hidden-xs">{date.test_count}</Td>
                <FailTd
                  selected={selectedDate === date.date && failureSelected}
                  count={date.pass_fail_count}
                  onClick={(e) => {
                    if (date.pass_fail_count === 0 && date.warning_count == 0) return;
                    loadSamplesForDate(date.date, true);
                    setFailureSelected(true);
                    e.stopPropagation();
                  }}
                >
                  {date.pass_fail_count}
                </FailTd>
                <WarningTd
                  selected={selectedDate === date.date && failureSelected}
                  count={date.warning_count}
                  onClick={(e) => {
                    if (date.pass_fail_count === 0 && date.warning_count == 0) return;
                    loadSamplesForDate(date.date, true);
                    setFailureSelected(true);
                    e.stopPropagation();
                  }}
                >
                  {date.warning_count}
                </WarningTd>
                <FailTd count={date.outstanding_todo_count} className="hidden-sm hidden-xs">
                  {date.outstanding_todo_count}
                </FailTd>
                <Td className="hidden-sm hidden-xs">{date.total_price}</Td>
              </tr>
            ))}
          </tbody>
        </SummaryTable>
      </div>
    </Container>
  );
}
